import React, { useEffect, useState } from "react";
import {
  deleteIconDark,
  editPencilIcon,
  minus,
  plusIcon,
} from "../../../assetData/icons";

const CellDropDown = ({
  cell,
  rowId,
  valueToGet,
  isDropDownVisible,
  setIsDelete,
  setSelectedItemId,
  setPayloadChange,
  setEdited,
  setRowEdit,
  rowEdit,
}) => {
  const [changes, setChanges] = useState([]);

  const handleChange = (e, key, id) => {
    const value = e.target.value === "true"; // Assuming the select gives "true" or "false" as strings.
    setChanges((prevChanges) => {
      const existingChange = prevChanges.find((change) => change.id === id);
      if (existingChange) {
        return prevChanges.map((change) =>
          change.id === id ? { ...change, [key]: value } : change,
        );
      } else {
        return [...prevChanges, { id, [key]: value }];
      }
    });
  };

  useEffect(() => {
    setPayloadChange((prevPayloadChanges) => {
      return changes.map((change) => {
        const existingChange = prevPayloadChanges.find(
          (item) => item.id === change.id,
        );
        if (existingChange) {
          return { ...existingChange, ...change };
        } else {
          return change;
        }
      });
    });
    setEdited(false);
  }, [changes]);

  return (
    <>
      {valueToGet === "sub_menu" && (
        <div className="mt-[-22px] flex h-[22px] w-full gap-1 px-2">
          <img
            src={
              isDropDownVisible && rowId.row.id === cell.id.split("_")[0]
                ? minus
                : plusIcon
            }
            alt=""
            className="w-[7px] cursor-pointer hover:scale-[1.5]"
          />
          <span>{cell.getValue()}</span>
        </div>
      )}
      <div className="ml-[-2.5px] w-[111.6%] transition delay-1000 ease-in-out">
        {rowId?.row?.id === cell.id.split("_")[0] && isDropDownVisible && (
          <span className="">
            {cell.row.original.submenus
              ?.filter((item) => item.action_pages === "")
              .map((item, index) => (
                <span
                  key={index}
                  className={`block w-full border-[1px] border-x-0 border-b-0 border-neutral-clr-300 bg-gray-100 px-2 py-1 text-[12px] font-medium text-[#636363] `}
                >
                  {valueToGet === "add_perm" ||
                  valueToGet === "edit_perm" ||
                  valueToGet === "view_perm" ||
                  valueToGet === "delete_perm" ||
                  valueToGet === "download_perm" ||
                  valueToGet === "import_perm" ? (
                    rowEdit === item?.id ? (
                      <div className="flex w-full justify-center">
                        <select
                          onChange={(e) => handleChange(e, valueToGet, item.id)}
                          className=" w-fit bg-gray-100 text-center focus:outline-none"
                          // disabled={editRow !== index}
                          defaultValue={item[valueToGet]}
                        >
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                      </div>
                    ) : (
                      <span className="flex h-[18px] items-center justify-center">
                        {item[valueToGet] ? "Yes" : "No"}
                      </span>
                    )
                  ) : valueToGet === "icons" ? (
                    <div className="flex h-[18px] items-center  justify-evenly px-1">
                      <button
                        onClick={() => {
                          setRowEdit(item.id);
                        }}
                        className="active:scale-90"
                      >
                        <img src={editPencilIcon} alt="i4invest" />
                        <p></p>
                      </button>

                      <button
                        onClick={() => (
                          setSelectedItemId(item.id), setIsDelete(true)
                        )}
                        className="active:scale-90"
                      >
                        <img src={deleteIconDark} alt="i4invest" />
                      </button>
                    </div>
                  ) : valueToGet === "main_menu_id" ||
                    valueToGet === "sub_menu_id" ||
                    valueToGet === "sort_order" ? (
                    <span className="flex h-[18px] items-center justify-center">
                      {item[valueToGet]}
                    </span>
                  ) : valueToGet === "sub_menu" ? (
                    <span className="flex h-[18px] items-center justify-start px-3">
                      {item[valueToGet]}
                    </span>
                  ) : valueToGet === "status" ? (
                    <span className="flex h-[18px] items-center justify-center ">
                      {item[valueToGet] ? "Active" : "Inactive"}
                    </span>
                  ) : valueToGet === "main_menu" ? null : (
                    <span className="">{item[valueToGet]}</span>
                  )}
                </span>
              ))}
          </span>
        )}
      </div>
    </>
  );
};

export default CellDropDown;
